import {AfterContentInit, AfterViewInit, Component} from '@angular/core';
import {
    ControlService,
    IconService,
    SubtitlesService,
    ViewsService
} from "../../../core";
import {MenuType} from "../../../models";

@Component({
    selector: 'manufacturer-data',
    templateUrl: './manufacturer-data.component.html',
    styleUrls: ['./manufacturer-data.component.scss']
})
export class ManufacturerDataComponent implements AfterViewInit,AfterContentInit {
    constructor(
        public control: ControlService,
        private icon: IconService,
        private subtitles: SubtitlesService,
        public views: ViewsService,
    ) {
    }

    ngAfterViewInit() {
        this.control.setOverflow();

    }

    ngAfterContentInit() {
        this.views.setManufacturerMaxHeight();
    }

    setIcon(val: number | MenuType): string {
        if (val === null) return;

        return this.icon.setIcon(val);
    }

    subtitle(val: number): string {
        return val !== 0 ? this.subtitles.setSubtitle(val) : '';
    }
}
